module.exports = __webpack_public_path__ + "assets/39e51e81494fc580800a15d9d4750138.png";